<div class="d-flex flex-column align-items-end w-100 gap-1">
  @if (textContent()) {
  <div class="user-bubble mat-font-body-sm">{{ textContent() }}</div>
  }
  <app-content-dispatcher class="w-100" [messageId]="message()?.id ?? ''" />
  <span class="mat-font-label-sm px-1 mat-text-on-surface-variant">
    {{ timestamp() | date: "HH:mm" }}
  </span>
</div>
